var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"preview"},[(_vm.image)?_c('img',{style:(_vm.style),attrs:{"src":_vm.image,"alt":_vm.file.original}}):_c('div',{ref:"preview",style:(_vm.style)})])
}
var staticRenderFns = []

export { render, staticRenderFns }